<div class="flex flex-col px-4 py-2 md:px-8 md:py-4" *ngIf="currentUser">

  <div class="flex justify-center items-center py-8" *ngIf="!memberCourses">
    <mat-spinner strokeWidth="3" diameter="100"></mat-spinner>
  </div>

  <!-- member courses are available -->
  <div *ngIf="memberCourses && memberCourses.length > 0" class="space-y-4">
    <div class="px-2 md:px-0">
      <h5 class="text-base md:text-lg font-semibold text-gray-500 mb-4">
        Courses Registered for {{ currentUser.fname }} {{ currentUser.lname }}
      </h5>
    </div>

    <div *ngFor="let memberCourse of memberCourses" class="w-full">
      <div *ngIf="findCourse(memberCourse.courseId)" class="w-full mb-4 bg-white rounded-lg shadow-md overflow-hidden">
        <div class="px-4 pt-4 pb-2">
          <h3 class="text-lg md:text-xl font-semibold text-gray-900">{{ findCourse(memberCourse.courseId)?.courseName }}</h3>
        </div>
        <div *ngIf="findCourse(memberCourse.courseId)" class="px-4 pt-2 pb-4">
          <div class="text-left text-sm md:text-base text-gray-700" [innerHTML]="sanitizeHtml(findCourse(memberCourse.courseId)?.courseDesc)">
          </div>
        </div>
        <div class="px-4 pb-4 flex justify-end">
          <button mat-raised-button color="primary" (click)="selectCourse(memberCourse.courseId)"
            *ngIf="memberCourse?.status == 'paid'" class="w-full md:w-auto">Continue Course</button>
          <button mat-raised-button color="primary"
            routerLink="/courses/{{memberCourse.courseId}}/payments" *ngIf="memberCourse?.status !== 'paid'" class="w-full md:w-auto">
            <mat-icon class="mr-1">payment</mat-icon>
            Purchase Course
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- no member courses -->
  <div *ngIf="memberCourses && memberCourses.length === 0" class="px-2 md:px-0 py-6 space-y-4">
    <div class="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 rounded-xl shadow-sm p-6 text-gray-700">
      <div class="flex items-start gap-3">
        <div class="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
          <mat-icon class="text-blue-600 !text-2xl">school</mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <h5 class="text-lg font-semibold text-gray-900 mb-2">Ready to get started?</h5>
          <p class="text-gray-700 mb-4">
            Explore our courses and find the right fit for you. Start your learning journey today.
          </p>
          <a href="https://www.keystodriving.com/courses" target="_blank" rel="noopener noreferrer" title="Opens in new window"
            class="inline-flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm hover:shadow transition-all duration-200">
            <mat-icon class="!text-xl !w-5 !h-5">add_shopping_cart</mat-icon>
            View Courses
          </a>
        </div>
      </div>
    </div>
    <div class="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-xl shadow-sm p-6 text-gray-800">
      <div class="flex items-start gap-3">
        <div class="flex-shrink-0 w-10 h-10 rounded-full bg-amber-200 flex items-center justify-center">
          <fa-icon [icon]="faInfoCircle" class="text-amber-800 text-xl"></fa-icon>
        </div>
        <div class="flex-1 min-w-0">
          <h5 class="text-lg font-semibold text-amber-900 mb-2">No courses found</h5>
          <p class="text-gray-700 mb-4">
            We cannot find your courses at this time. If you have recently purchased a course from us, please contact our support team—we’re here to help.
          </p>
          <div class="space-y-3">
            <p class="mb-0 flex items-center gap-2">
              <mat-icon class="text-amber-600 !text-lg !w-5 !h-5">email</mat-icon>
              <span>Email us at <a href="mailto:support@keystodriving.com" class="text-blue-600 hover:underline font-medium">support&#64;keystodriving.com</a></span>
            </p>
            <p class="mb-0 flex items-center gap-2">
              <mat-icon class="text-amber-600 !text-lg !w-5 !h-5">phone</mat-icon>
              <span>Or call <a href="tel:+16104901922" class="text-blue-600 hover:underline font-medium">(610) 490-1922</a></span>
            </p>
            <p class="mb-0 flex items-center gap-2">
              <mat-icon class="text-amber-600 !text-lg !w-5 !h-5">contact_support</mat-icon>
              <span>Or submit your query via our <a href="http://www.keystodriving.com/contact-us" target="_blank" rel="noopener noreferrer" title="Opens in new window" class="text-blue-600 hover:underline font-medium">contact-us form</a></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
